import { ApiService } from 'services';
import { toastr } from 'react-redux-toastr';

import { handleException } from 'actions/exceptions';

export const EDIT_ACCOUNT_NAME = 'EDIT_ACCOUNT_NAME';
export const EDIT_ACCOUNT_NAME_CANCEL = 'EDIT_ACCOUNT_NAME_CANCEL';
export const UPDATE_ACCOUNT_NAME_REQUEST = 'UPDATE_ACCOUNT_NAME_REQUEST';
export const UPDATE_ACCOUNT_NAME_SUCCESS = 'UPDATE_ACCOUNT_NAME_SUCCESS';
export const UPDATE_ACCOUNT_NAME_ERROR = 'UPDATE_ACCOUNT_NAME_ERROR';

function edit() {
  return {
    type: EDIT_ACCOUNT_NAME
  };
}

function cancelEdit() {
  return {
    type: EDIT_ACCOUNT_NAME_CANCEL
  };
}

function request() {
  return {
    type: UPDATE_ACCOUNT_NAME_REQUEST
  };
}

function receive(accountName) {
  return {
    type: UPDATE_ACCOUNT_NAME_SUCCESS,
    accountName
  };
}

function reject() {
  return {
    type: UPDATE_ACCOUNT_NAME_ERROR
  };
}

export function editAccountName() {
  return (dispatch) => {
    dispatch(edit());
  };
}

export function cancelEditAccountName() {
  return (dispatch) => {
    dispatch(cancelEdit());
  };
}

export function updateAccountName(accountId, accountName) {
  const formData = new FormData();
  formData.append('accountName', accountName);

  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .updateAccountName(accountId, formData)
      .then(() => {
        dispatch(receive(accountName));
        toastr.success('Success', 'Account name updated successfully');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
